import React from "react";

const STATUS_STYLE = {
  FREE:    "bg-gray-50 text-gray-700 hover:bg-blue-50 hover:text-blue-700 border-gray-200",
  BOOKED:  "bg-blue-100 text-blue-800 border-blue-200",
  BLOCKED: "bg-red-50 text-red-600 border-red-200",
};

export default function AgendaSlotCell({ slot, onClick }) {
  const time = new Date(slot.startAt).toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const cls = STATUS_STYLE[slot.status] ?? STATUS_STYLE.FREE;
  const leadName = slot.appointment?.session?.lead?.name;

  return (
    <button
      type="button"
      onClick={() => onClick(slot)}
      title={
        slot.status === "BOOKED"
          ? `Reunião com ${leadName ?? "?"}`
          : slot.status === "BLOCKED"
            ? "Bloqueado"
            : "Livre — clique para bloquear"
      }
      className={`w-full px-2 py-1 text-xs font-medium border rounded transition ${cls}`}
    >
      <div className="flex items-center justify-between gap-1">
        <span>{time}</span>
        {slot.status === "BOOKED" && leadName && (
          <span className="truncate max-w-[80px]">{leadName}</span>
        )}
        {slot.status === "BLOCKED" && <span>✕</span>}
      </div>
    </button>
  );
}
